import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { Directory } from '@capacitor/filesystem';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { ModalController } from '@ionic/angular';
import { FileHelper } from '@osapp/helpers/fileHelper';
import { FilesystemService } from '@osapp/modules/filesystem/services/filesystem.service';
import { ModalComponentBase } from '@osapp/modules/modal/model/ModalComponentBase';
import { Queuer } from '@osapp/modules/utils/queue/models/queuer';
import { PlatformService } from '@osapp/services/platform.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { IAccordPrealable } from '../../../../patients/model/IAccordPrealable';

interface IApItem {
	blob: Blob;
	name: string;
	url: string;
}

interface IDownloadFspParams {
	accord: IAccordPrealable;
	apItem: IApItem;
}

@Component({
	selector: 'di-ap-list-modal',
	templateUrl: './accordPrealable-list-modal.component.html',
	styleUrls: ['./accordPrealable-list-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordPrealableListModalComponent extends ModalComponentBase<boolean> {

	//#region FIELDS 

	private readonly moQueuer = new Queuer({ excludePendings: true, thingToQueue: (poParams: IDownloadFspParams) => this.downloadPdfAsync(poParams.apItem) });

	//#endregion

	//#region PROPERTIES

	@Input() public ApList = new Map<IAccordPrealable, IApItem[]>();

	public get canPreview(): boolean {
		return !this.isvcPlatform.isMobileApp;
	}

	//#endregion

	constructor(
		private readonly isvcFilesystem: FilesystemService,
		private readonly ioFileOpener: FileOpener,
		poModalCtrl: ModalController,
		psvcPlatform: PlatformService,
		poChangeDetectorRef: ChangeDetectorRef
	) {
		super(poModalCtrl, psvcPlatform, poChangeDetectorRef);

		this.moQueuer.start().pipe(takeUntil(this.destroyed$), finalize(() => this.moQueuer.end())).subscribe();
	}

	public goToPdf(poFsp: IApItem): void {
		window.open(poFsp.url, '_blank');
	}

	public onDownloadPdfClicked(accordPrealable: IAccordPrealable, poAp: IApItem): void {
		this.moQueuer.exec({ accord: accordPrealable, apItem: poAp });
	}

	private async downloadPdfAsync(poAp: IApItem): Promise<void> {
		const lsInvoicePdfName = `Accord Prealable.pdf`;
		if (this.isvcPlatform.isMobileApp) {
			const lsPath = `Download/${lsInvoicePdfName}`;

			const lsUri = await this.isvcFilesystem.createFileAsync(lsPath, poAp.blob, Directory.ExternalStorage, true);
			await this.ioFileOpener.open(lsUri, "application/pdf");
		}
		else
			FileHelper.downloadBlob(poAp.blob, lsInvoicePdfName);
	}

}
